import ButtonIcon from "ds/components/ButtonIcon";
import { LayoutContext } from "components/layout/Context";
import { List } from "components/icons/generated";
import useTypedContext from "hooks/useTypedContext";

import styles from "./styles.module.css";

const FiltersMobileTriggerButton = () => {
  const { setShowFilters } = useTypedContext(LayoutContext);
  return (
    <ButtonIcon
      size="medium"
      variant="secondary"
      onPress={() => setShowFilters(true)}
      icon={List}
      className={styles.button}
    >
      Show filters
    </ButtonIcon>
  );
};

export default FiltersMobileTriggerButton;
